import React from 'react'
import PropTypes from 'prop-types'

// extends React.Component is required because of reference in parent
export default class FieldRating_DropdownOption extends React.Component<any,any> {

    static propTypes = {
        scale           : PropTypes.number,

        option          : PropTypes.object,

        isHighlighted   : PropTypes.bool,
        isSelected      : PropTypes.bool,

        onClick         : PropTypes.func,
    }

    onClick = () => {this.props.onClick(this.props.option)}

    render() {
        const classes = Classes('option', 'pill', {
            'highlighted': this.props.isHighlighted
        })

        const stars = new Array(this.props.scale).fill(true).fill(false, this.props.option.value);

        return (
            <div className={classes} onClick={this.onClick}>
                {!this.props.option.isNoValueOption &&
                    <div className="ui5-selector-rating">
                        {_.map(stars, (value, key)=>{
                            const classes = Classes("icon", {
                                'filled i5-star'       : value,
                                'empty i5-star-empty'  : !value,
                            })
                            return <div key={key} className={classes}/>
                        })}
                    </div>}

                {!!this.props.option.isNoValueOption &&
                    <div className="ui5-txt-default">{this.props.option.label}</div>}
            </div>
        )
    }
}